var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIDental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.119 34.179c4.725 0 6.916 3.587 7.378 8.679 0.109 1.219-0.005 2.995-0.161 5.053-0.531 6.836-1.142 15.236 3.41 15.236 3.849 0 5.827-7.386 6.968-15.804 1.102-8.334-0.065-12.481 0.508-16.181 1.094-7.011 7.215-13.297 5.324-22.237-1.047-4.959-3.777-7.292-6.483-8.272-6.231-2.268-10.255 2.102-16.946 2.102-6.691 0-10.714-4.37-16.948-2.102-2.703 0.98-5.433 3.313-6.482 8.272-1.889 8.939 4.229 15.226 5.326 22.237 0.573 3.7-0.593 7.847 0.509 16.181 1.141 8.419 3.119 15.804 6.968 15.804 4.549 0 3.942-8.4 3.41-15.236-0.156-2.057-0.271-3.834-0.162-5.053 0.46-5.092 2.682-8.679 7.379-8.679z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDental);
export default __webpack_public_path__ + "static/media/i-dental.bfbf4e47.svg";
export { ForwardRef as ReactComponent };